import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/context/AuthContext";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card max-w-xl space-y-6" data-testid="forgot-password-page">
      <h1 className="text-base md:text-lg font-semibold">Reset your password</h1>
      <p className="text-sm text-muted-foreground" data-testid="forgot-password-roster-hint">
        Use the email your instructor or GDI Academy already has on file. This claims your existing account — it does
        not create a duplicate. After resetting, verify your email if prompted before logging in.
      </p>
      {result ? (
        <div className="space-y-4">
          <p data-testid="forgot-password-message">{result.message}</p>
          {!result.dev_reset_link && (
            <p className="text-sm text-muted-foreground" data-testid="forgot-password-email-hint">
              If an account exists for that email, check your inbox for a reset link.
            </p>
          )}
          {result.dev_reset_link && (
            <>
              <p className="text-sm text-muted-foreground">
                Non-production spike: no email server, so use the reset link below directly.
              </p>
              <Link to={result.dev_reset_link} className="btn-primary inline-block" data-testid="dev-reset-link">
                Reset my password
              </Link>
            </>
          )}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1">
            <label htmlFor="forgot-email" className="font-medium">Email</label>
            <input
              id="forgot-email"
              data-testid="forgot-email-input"
              className="input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {error && <p role="alert" className="text-destructive" data-testid="forgot-error">{error}</p>}
          <button type="submit" className="btn-primary" disabled={busy} data-testid="forgot-submit-button">
            {busy ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
      <p className="text-sm text-muted-foreground">
        <Link to="/login" className="underline" data-testid="forgot-login-link">Back to log in</Link>
      </p>
    </div>
  );
}
